const openingParagraph = {
  workingInSpace: [
    ` יום העבודה מורכב מפעילויות שונות, לכן תכננו את המשרדים שלנו כך שיתאימו
        למגוון הפעילויות האלו. מכירים את גישת Activity Based Working (או
        בקיצור ABW)? המשמעות היא שלצד עמדות העבודה המצוידות שלכם, תמצאו חדרי
        ישיבות רשמיים, חדרי ישיבות יותר חופשיים, חללי שיתוף פעולה, ספרייה
        לעבודה שששקטה, קפיטריה גדולה, אזורי פנאי למפגשים חברתיים, בית קפה עם
        בריסטה אמיתי וגג מטופח ומגניב, שתוכלו להסתכל על כולם מלמעלה (אבל בקטע
        מעצים!)`,
    `בקומות 8 ו- 9 ריכזנו מרחבים לפעילות קבוצתית או חברתית מסוגים שונים:`,
  ],

  health: [``, ``],

  food: [
    `עובדי NICE נהנים ממתחם אוכל עשיר ומגוון הממוקם בקומה 8 ומציע חומרי גלם טריים מידי יום. וכשבא לכם להתפנק במשלוח, דאגנו גם לזה. `,
    ``,
  ],
}

export default openingParagraph
